/**
* @Author: Matthias Gohla <Matze>
* @Date:   2016-09-23T16:59:08+02:00
* @Email:  matze_lebt@gmx.de
* @Last modified by:   mBook
* @Last modified time: 2016-10-07T15:29:33+02:00
*/


import React, {Component} from 'react';
import PropTypes from 'prop-types';
import CSSTransition from 'react-transition-group/CSSTransition';
import AButtonIcon from './../../common/buttons/components/AButtonIcon';
import AutoLockScrolling from './../../internals/AutoLockScrolling';
import breakpointProps from './../../utilities/breakpointProp';

/**
 * OHelpCheckout - …
**/
class OHelpCheckout extends Component {
  /**
     * TODO jsdoc
     *
     * @return {object}
     */
  render() {
    const {
      children,
      show,
      onPressClose,
      breakpoint,
      offsetTop,
    } = this.props;
    // let helpContent = null;
    const showClass = (show) ? 'show' : '';

    const lockBackground = (breakpoint !== 'checkout' && breakpoint !== 'wide' && show);
    // we need these flags for position of help dialog in iframe (BAD HAX!!)
    const isMobile = breakpoint !== 'checkout' && breakpoint !== 'wide';
    const isIframe = window.parent != window && offsetTop > 0;

    // TODO make button component
    const closeBtn = (
      <AButtonIcon
        icon="remove"
        iconSize="small"
        onPress={onPressClose}
        style={isIframe && isMobile ? {top: offsetTop + 'px'} : {}}
      />
    );
    return (
      <div className={`o-help o-help-checkout ${showClass}`} style={!isMobile ? {top: offsetTop} : {}}>
        <AutoLockScrolling lock={lockBackground} />
        <div className="o-help-checkout__content" style={isIframe && isMobile ? {'margin-top': offsetTop + 'px'} : {}}>
          <CSSTransition
            classNames="o-help-checkout__content-animation"
            appear
            timeout={{enter: 800, exit: 1}}
          >
            {children || <div/>}
          </CSSTransition>
        </div>
        {closeBtn}
      </div>
    );
  }
}

OHelpCheckout.propTypes = {
  children: PropTypes.any,
  show: PropTypes.bool,
  onPressClose: PropTypes.func,
  breakpoint: PropTypes.string.isRequired,
};
OHelpCheckout.defaultProps = {};
export default breakpointProps(OHelpCheckout);


/**

<VelocityTransitionGroup
    runOnMount
    enter={{ animation: 'transition.slideRightBigIn' }}
    leave={{ animation: 'transition.slideRightBigOut' }}
>
    {helpContent}

</VelocityTransitionGroup>
 */

